import $ from 'jquery';
import angular from 'angular';

require('expose-loader?$!expose-loader?jQuery!jquery');
require('expose-loader?ko!knockout');
require('expose-loader?_!underscore');

require('angular-file-upload');
require('angular-ui-date');
require('angular-ui-select2/src/select2');
require('angular-ui-tinymce');
require('fancybox');
require('jquery.easing');
require('jquery-ui/ui/autocomplete');
require('jquery-ui/ui/datepicker');
require('knockout');
require('select2');
require('superfish');

const appRequires = [
  'angularFileUpload',
  'ui.date',
  'ui.select2',
  'ui.tinymce',
];

angular.module('app.admin', appRequires);

require('./services');
require('./controllers');

$.extend($.expr[':'], {
  'contains-ci': function (elem, i, match) {
    return (elem.textContent || elem.innerText || $(elem).text() || '')
      .toLowerCase()
      .indexOf((match[3] || '')
      .toLowerCase()) >= 0;
  }
});

$(document).ready(function() {
  const submenu = $('ul.sf-menu');
  if (submenu.length > 0) {
    submenu.superfish();
  }

  $('#top-nav li.login a.login_box').click(function(e) {
    e.preventDefault();
    $(this).parent().toggleClass('selected');
    $('#top-nav li.login > div').slideToggle('fast');
  });

  const button = $('a.left-hide-button');
  button.click(function(e) {
    e.preventDefault();
    $(this).next().toggleClass('expanded');
    $(this).next().next().toggle();
  });

  const userbar = $('div#userbar');
  userbar.find('a.quick-add').click(function(e) {
    e.preventDefault();
    const linkClass = $(this).prop('class');
    const shownSlider = userbar.find('div.slide-down.shown');
    shownSlider.animate({height:'toggle'}, 200).removeClass('shown');
    if (!shownSlider.hasClass(linkClass)) {
      var slider = userbar.find('div.' + $(this).prop('class'));
      slider.animate({height:'toggle'}, 200).addClass('shown');
    }
  });
});



// WEBPACK FOOTER //
// ./front/js/admin/app.boot.js